import axios from 'axios';

// 240s default — admin endpoints that hit upstream LLM/image models can
// legitimately take a few minutes. Browsers don't enforce a wall-clock so the
// only reason for a short timeout is to surface dead sockets faster, which
// matters less here than user impatience for slow inference.
const request = axios.create({
  baseURL: '/api',
  timeout: 240000,
  headers: {
    'Content-Type': 'application/json',
  },
});

request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

request.interceptors.response.use(
  (response) => {
    // Unwrap ApiResponse: { success, data, error } -> return data field
    const body = response.data;
    if (body && typeof body === 'object' && 'success' in body) {
      if (!body.success) {
        return Promise.reject(new Error(body.error || 'Request failed'));
      }
      // Return a modified response with data unwrapped
      response.data = body.data;
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      window.location.href = '/login';
    }
    // Extract error message from API response
    const apiError = error.response?.data?.error;
    if (apiError) {
      error.message = apiError;
    }
    return Promise.reject(error);
  },
);

export default request;
